import React from 'react';
import { Helmet } from "react-helmet";

const CareersAndJobs = () => (
  <>
    <Helmet>
      <title>Careers & Jobs | Platform Engineering | Fepsec</title>
    </Helmet>
    <div className="py-16 bg-gradient-to-b from-gray-50 to-gray-100 min-h-screen">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-extrabold text-gray-800 mb-8" data-aos="fade-up">
            Careers at Fepsec
          </h1>
          <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-l-4 border-blue-600" data-aos="fade-up" data-aos-delay="100">
            <p className="text-lg text-gray-700 mb-6">
              Join our team of passionate engineers, consultants, and innovators. We are always looking for talented professionals to help us build the future of cloud-native technology.
            </p>
            <ul className="list-disc ml-8 mb-6 text-gray-700">
              <li>Open positions in engineering, consulting, and training</li>
              <li>Remote and on-site opportunities</li>
              <li>Continuous learning and growth</li>
              <li>Inclusive and diverse work environment</li>
            </ul>
            <p className="text-gray-700">
              Check back soon for open positions or send your CV to <a href="mailto:careers@fepsec.com" className="text-primary underline">careers@fepsec.com</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default CareersAndJobs;
